// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"77e2695a","2792":"37ac7ee0","6183":"77e2695a","7962":"77e2695a"}[chunkId] + ".chunk.css";
};